/* global customElements, HTMLElement */

// import { ask } from './consent.js'

/**
 * Third-party components embedded via iframe with 2-click consent.
 */
class EmbedElement extends HTMLElement {
  // constructor () {
  //   super()
  // }

  connectedCallback () {
    this.$poster = this.querySelector('.js-embed__poster')
    this.$consent = this.querySelector('.js-embed__consent')
    this.$load = this.querySelector('.js-embed__load')
    this.$load.addEventListener('click', (e) => this.load(e))

    this.isLoaded = false
  }

  async consent () {
    // try {
    //   await ask('embed', {
    //     providerName: this.$el.dataset.providerName,
    //     providerUrl: this.$el.dataset.providerUrl,
    //     providerPrivacyUrl: this.$el.dataset.providerPrivacyUrl
    //   })
    //   return true
    // } catch (e) {
    //   return false
    // }
    return true
  }

  get provider () {
    return this.dataset.provider
  }

  async load (e) {
    if (this.isLoaded) {
      return
    }

    if (!(await this.consent())) {
      return
    }

    this.$iframe = document.createElement('iframe')
    const allow = this.dataset.allow
    this.$iframe.setAttribute('allow', allow)
    if (allow.split(' ').includes('allowfullscreen')) {
      this.$iframe.setAttribute('allowfullscreen', 'allowfullscreen')
    }

    this.$iframe.className = 'embed__iframe'
    this.$iframe.setAttribute('src', this.dataset.src)
    this.$iframe.setAttribute('tabindex', '0')

    this.$consent.after(this.$iframe)
    this.$poster.hidden = true
    this.$consent.hidden = true
    this.isLoaded = true

    this.$iframe.focus({ preventScroll: true })
  }

  unload () {
    if (!this.isLoaded) {
      return
    }

    if (!this.$iframe) {
      return
    }

    this.$iframe.remove()
    delete this.$iframe
    this.$poster.hidden = false
    this.$consent.hidden = false
    this.isLoaded = false
  }

  async play () {
    await this.load()

    if (!this.$iframe) {
      return
    }

    if (this.provider === 'vimeo') {
      this.$iframe.contentWindow.postMessage(
        JSON.stringify({
          method: 'play'
        }),
        '*'
      )
    } else if (this.provider === 'youtube') {
      this.$iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'playVideo',
          args: []
        }),
        '*'
      )
    }

    this.$iframe.focus({ preventScroll: true })
  }

  pause () {
    if (!this.isLoaded) {
      return
    }

    if (this.provider === 'vimeo') {
      this.$iframe.contentWindow.postMessage(
        JSON.stringify({
          method: 'pause'
        }),
        '*'
      )
    } else if (this.provider === 'youtube') {
      this.$iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: []
        }),
        '*'
      )
    }
  }
}

customElements.define('x-embed', EmbedElement)
